import { UserCheck, SprayCan, Clock, Accessibility, DoorOpen, Star } from "lucide-react";

const benefits = [
  {
    icon: UserCheck,
    title: "Professional Drivers",
    description: "Trained, courteous drivers focused on patient comfort and safety.",
  },
  {
    icon: SprayCan,
    title: "Clean Vehicles",
    description: "Spotless, well-maintained vehicles sanitized before every trip.",
  },
  {
    icon: Clock,
    title: "On-Time Pickups",
    description: "We value your time — arrive on schedule, every appointment.",
  },
  {
    icon: Accessibility,
    title: "Wheelchair Accessible Vans",
    description: "Equipped with ramps and tie-downs for safe wheelchair transport.",
  },
  {
    icon: DoorOpen,
    title: "Direct Door-to-Door Service",
    description: "We pick you up at your door and take you right to your destination.",
  },
  {
    icon: Star,
    title: "Trusted & Reliable",
    description: "Serving the Portland community with integrity and compassion.",
  },
];

const WhyChoose = () => {
  return (
    <section className="py-14 sm:py-20 bg-background">
      <div className="container mx-auto px-4">
        <div className="text-center mb-10 sm:mb-14">
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-bold text-foreground mb-3 sm:mb-4">
            Why Choose ANEMT
          </h2>
          <p className="text-base sm:text-lg text-muted-foreground max-w-2xl mx-auto">
            Dedicated to safe, reliable, and professional medical transportation
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8 max-w-6xl mx-auto">
          {benefits.map((benefit, index) => (
            <div key={index} className="flex items-start space-x-3 sm:space-x-4 p-3 sm:p-4 rounded-2xl hover:bg-muted transition-colors duration-200">
              <div className="flex-shrink-0 w-10 h-10 sm:w-12 sm:h-12 rounded-xl bg-primary/10 flex items-center justify-center">
                <benefit.icon className="h-5 w-5 sm:h-6 sm:w-6 text-primary" />
              </div>
              <div>
                <h3 className="text-base sm:text-lg font-semibold text-foreground mb-1 sm:mb-1.5">
                  {benefit.title}
                </h3>
                <p className="text-xs sm:text-sm text-muted-foreground leading-relaxed">
                  {benefit.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
